import type { Application } from '@src/@types/app';
import { Experiments } from '@src/constants/abTest';
import { CHANNELS } from '@src/constants/advertising';
import { DEFAULT_FILTERS, FILTERS_NAMES, FILTERS_SCHEME, MODES } from '@src/constants/filters';
import type { ListKeys } from '@src/constants/microcredits';
import { getUserPhoneForChecker } from '@src/helpers/getUserPhoneForChecker';
import { parse } from '@src/helpers/query';
import { CookieKey } from '@src/modules/cookie';
import { fetchOffers } from '@src/reducers/microcredits';
import { getCookieFromServerOrClient } from '@src/utils/getCookieFromServerOrClient';

export const getPageLandingData = async (
  ctx: Application.ReduxNextPageContext,
  key: ListKeys,
  filtersKey = MODES.LANDING,
) => {
  const {
    store: { dispatch },
    params: { locationRoute },
  } = ctx;

  const query = parse({
    defaultValues: DEFAULT_FILTERS[filtersKey],
    query: ctx.query,
    scheme: FILTERS_SCHEME,
  });

  const clientId = getCookieFromServerOrClient(ctx, CookieKey._ym_uid);

  const filterParams = {
    [FILTERS_NAMES.LOCATION]: locationRoute,
    [FILTERS_NAMES.ROUTE]: { asPath: ctx.asPath ?? '', query: ctx.query ?? {} },
    ...(Boolean(clientId) && {
      [FILTERS_NAMES.CLIENT_ID]: clientId,
    }),
    ...getUserPhoneForChecker(ctx),
  };

  return dispatch(fetchOffers({ key, query, params: filterParams }));
};
